import { isEqual } from 'lodash-es';
import type { Context, NextEvent } from '../../checkout.machine.types';
import { updateInvoiceDetails } from '../events';

export const isAmendmentOrReactivation = ({
  hasCancelledSubscription,
  hasActiveSubscription,
}: Context): boolean => hasCancelledSubscription || hasActiveSubscription;

export const customerIsUnchanged = (context: Context, event: NextEvent): boolean => {
  const newCustomer = updateInvoiceDetails(context, event).customer;

  return isAmendmentOrReactivation(context) && isEqual(newCustomer, context.customer);
};

export const shouldSkipCustomerUpdate = (context: Context, { skip }: NextEvent): boolean =>
  isAmendmentOrReactivation(context) && skip === true;
